/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
export const en_us_values = {
  code: "en_us",
  label: "English",
};

export const en_us = {
  1: "#{LABEL}# cannot be greater than #{FIELDLENGTH}#",
  3: "#{LABEL}# does not match",
  4: "#{LABEL}# is invalid",
  5: "#{LABEL}# is required",
  6: "#{LABEL}# is too early",
  7: "#{LABEL}# is too late",
  8: "#{LABEL}# must be #{FIELDLENGTH}# characters",
  9: "#{LABEL}# must be #{FIELDMAXLENGTH}# characters or fewer",
  12: "#{LABEL}# must be at least #{FIELDMIN}#",
  13: "#{LABEL}# must be at least #{FIELDMINLENGTH}# characters",
  16: "#{LENGTH}#-digit",
  17: "#{TITLE}# has no thermostats enrolled yet.",
  22: "A day must have at least one time period.",
  24: "Access Restrictions",
  25: "Access Restrictions saved successfully.",
  26: "Access Restrictions can block or limit features and restrict settings on your thermostat.",
  27: "Account Created",
  28: "Account Recovery",
  29: "Activate",
  30: "Activation Code",
  31: "Add Period",
  32: "Advanced",
  33: "Alert sent when temperature is above",
  34: "Alert sent when temperature is below",
  35: "Alerts",
  36: "Alerts saved successfully.",
  37: "All Alphabetically",
  38: "Allow access to all features in MENU and SETTINGS screens allows the user to change everything.",
  39: "Allows users to start a timed override when unoccupied or change temperature setpoints on HOME screen when occupied.",
  40: "An error occurred.",
  41: "Unknown Error",
  43: "App Settings",
  44: "Apply",
  45: "Apply #{LABEL}# to additional thermostats?",
  47: "Apply access restriction to additional thermostats?",
  48: "Apply alert settings to additional thermostats?",
  49: "Apply Changes To",
  50: "Are you sure you want to change your PIN?",
  51: "Are you sure you want to clear all alert notifications?",
  52: "Are you sure you want to delete #{NAME}#?",
  53: "Are you sure you want to delete this Building?",
  54: "Are you sure you want to delete this User?",
  55: "Are you sure you want to delete this?",
  56: "Are you sure you want to log out?",
  57: "Are you sure you want to remove #{NAME}# from Pivot?",
  59: "Authentication Type",
  64: "Building Configuration",
  65: "Building Dashboard",
  66: "Building Details",
  67: "By accessing Pivot App you accept and agree to be bound by the ", // Combined with 339
  68: "Call Support #{PHONENUMBER}#",
  69: "Cancel",
  70: "Cannot create a new period. There is a maximum of #{MAXOCCPERIODSPERDAY}# occupied periods per day.",
  71: "Changed #{TITLE}# to #{LABEL}#",
  73: "Changing #{MODELABEL}# to #{OPTIONLABEL}#",
  74: "Changing #{TITLE}# to #{LABEL}#",
  77: "Clear",
  78: "Clear All",
  79: "Compressor",
  80: "Compressor Speed",
  81: "Confirm your PIN",
  83: "Continue",
  87: "Cool To",
  88: "Cool To: {setpoint}°",
  89: "Cool To: {setpoint}. Heat To: {setpoint}°",
  93: "Create Group",
  94: "Daily",
  95: "Dashboard",
  96: "Delete",
  97: "Deleting",
  98: "Demo – save does not occur",
  99: "Device Ordering",
  100: "Devices",
  102: "Devices first (default)",
  103: "Disables access to the MENU screen and SYSTEM and FAN MODE but allows temperature setpoint adjustment and timed overrides.",
  104: "Disables access to the MENU screen but allows SYSTEM and FAN MODE changes and as well as temperature setpoint adjustment and timed overrides.",
  105: "Disassociate From Your Account",
  106: "DISMISS",
  107: "Done",
  109: "Edit Group",
  110: "Email",
  111: "Email Address",
  112: "Email Address is invalid",
  113: "Email Address is required",
  114: "Email Support",
  115: "Enable Service Contractor to see Information about your Thermostats",
  116: "Enroll New Device",
  117: "Enrollment failed.",
  118: "Enter your 12-digit activation code",
  119: "Enter your email address and we will send you an email to recover your username.",
  120: "Enter your PIN",
  122: "Enter your username and we will send you an email to reset your password.",
  123: "Entries don't match, please enter your PIN again.",
  124: "Events",
  125: "Exit Demo",
  126: "Explore Demo",
  127: "Failed to change #{TITLE}# to #{LABEL}#",
  128: "Failed to load thermostat's active schedule. Do you want to choose a saved schedule?",
  131: "For your security we cannot confirm whether the #{PROVIDEDCREDENTIAL}# you entered was correct. If you do not receive your email try again and make sure your #{PROVIDEDCREDENTIAL}# is entered correctly.", // Combined with 272, 153
  132: "Forgot your PIN",
  133: "Get Activation Code",
  134: "Get Code",
  135: "Go Back",
  137: "Groups first",
  140: "Heat To",
  141: "Heat To: {setpoint}°",
  142: "Heat To: #{setpoint}#. Cool To: {setpoint}°",
  144: "Help",
  145: "High",
  146: "Space Temperature Alert Enabled",
  147: "History",
  148: "Humidity",
  149: "I forgot my Username or Password",
  150: "I understand the risks",
  151: "If you are ready to add a thermostat to #{TITLE}#, tap Enroll New Device button below.",
  152: "If you continue this user will not be able to control anything in your account until you complete the activation process again. Are you sure you want to generate a new activation code for this user?",
  153: "If you do not receive the email please check your spam folder and make sure that you are not blocking email from #{SUPPORT}#.", // Combined with 272, 131
  154: "Invalid PIN. Please try again.",
  156: "Main Menu Passcode requires Access Restrictions set to Low, Medium or High.",
  157: "Last Updated #{TIME}#",
  158: "License Information",
  160: "Load",
  162: "Loading '#{BUILDINGNAME}#'",
  163: "Loading Account Sign Up",
  164: "Loading Alerts",
  165: "Loading building",
  166: "Loading daily runtime history...",
  167: "Loading default schedule",
  168: "Loading devices...",
  169: "Loading monthly runtime history...",
  170: "Loading Reset Password",
  171: "Loading schedule list",
  172: "Loading Setpoints",
  173: "Loading thermostat schedule",
  174: "Loading...",
  175: "Log In",
  176: "Log Out",
  177: "Login",
  178: "Low",
  179: "Manage Users",
  180: "Manufacturer",
  181: "Medium",
  184: "Monthly",
  185: "More",
  186: "My Buildings",
  187: "Name",
  188: "New Activation Code",
  189: "New Building",
  190: "New Period",
  191: "New User",
  192: "No",
  193: "No alerts are active.",
  194: "No Authorization",
  196: "No Recent Activity Found.",
  197: "None",
  198: "Please select a building to enable Group creation and Device enrollment.", // Combined with 357
  200: "Occupancy Setpoints",
  201: "Occupied",
  202: "Occupied Time Remaining",
  204: "OK",
  206: "Open Source License Information",
  207: "Operation complete.",
  208: "OS Version",
  209: "Outside",
  210: "Password reset successful.",
  213: "PIN entry disabled for #{MINUTES}# minutes.",
  214: "PIN Length",
  215: "PIN saved successfully.",
  216: "Pivot Mobile App Version",
  217: "Pivot™ Mobile App",
  218: "Platform",
  219: "Please enter a new PIN",
  220: "Please exercise caution when removing user authorization from the app. Due to the risk of unauthorized access, Pivot strongly recommends keeping the app locked unless this mobile device has a lock screen enabled.",
  221: "Please fill out the following information to reset your password.",
  222: "Please re-enter your username and password to manage the users of your Pivot™ account. You will not have to do this again.",
  223: "Pointed to #{HOST}#",
  224: "Postal Code",
  225: "Privacy Policy",
  226: "Recover Username",
  228: "Refresh Devices",
  229: "Remove #{NAME}# from Pivot",
  230: "Remove Period",
  231: "Reset Password",
  232: "Reset PIN",
  233: "Restart the App",
  234: "Prevent unauthorized access to the thermostat using a Passcode.",
  235: "Restrictions: Access Level",
  236: "Restrictions: Passcode",
  237: "Retrieving daily runtime history",
  238: "Retrieving monthly runtime history",
  239: "Retry",
  240: "Runtime History",
  241: "Save",
  242: "Save As",
  243: "Saved Schedules",
  244: "Saving Access Restriction...",
  245: "Saving Alerts...",
  246: "Schedules",
  247: "Scheduling could not be enabled. Please try again later.",
  248: "Scheduling enabled.",
  249: "Scheduling is disabled on this thermostat. Enable scheduling?",
  250: "SELECT PAGE",
  251: "Send Suggestions or Feedback",
  252: "Service Unavailable",
  253: "Set a #{LENGTH}#-digit PIN",
  254: "Set an 8-digit PIN",
  255: "Setpoints",
  256: "Setting cool to #{SETPOINTCOOL}#",
  257: "Setting heat to #{SETPOINTHEAT}#",
  258: "Setting heat to #{SETPOINTHEAT}# and cool to #{SETPOINTCOOL}#",
  259: "Settings",
  260: "Sign In",
  261: "Sign Up",
  262: "Sign Up Now",
  264: "Something went wrong while showing this page.",
  266: "Submit",
  267: "Successfully enrolled #{NAME}#.",
  268: "Support & Feedback",
  270: "Terms and Conditions",
  271: "Terms of Use",
  272: "Thank you. You should receive an email shortly with #{REQUESTEDEMAIL}#. The email may take 5-10 minutes to arrive.", // Combined with 153, 131
  274: "The following open source packages are used by the Pivot™ Mobile App.",
  275: "The following period is too close to create a new period.",
  276: "The preceding period is too close to create a new period.",
  277: "Request timed out.",
  280: "Thermostats",
  281: "This action cannot be completed because your account must have a minimum of one building.",
  282: "This group is empty. Edit the group to add devices.",
  283: "This mobile device needs to be reauthenticated.",
  284: "This operation cannot be performed while the device is offline.",
  285: "This thermostat is not compatible with Trane Pivot.",
  286: "To configure alerts for an individual thermostat click the Settings icon -", // Combined with 331
  287: "To enroll this thermostat under #{BUILDINGNAME}# click Get Code to generate a 5-digit code for you to enter at the thermostat.",
  288: "To enroll this thermostat under a different building click on Building Dashboard select desired building and then reselect enroll device under menu.",
  289: "To subscribe or modify your subscribed alerts press the Alert Subscriptions button above.",
  291: "Undo",
  292: "Unenrolling #{NAME}#",
  294: "Unlock App",
  295: "Unlock with Biometrics",
  296: "Unlock with PIN",
  297: "Unlock with PIN only",
  298: "Unoccupied",
  299: "Use 12-Digit Code",
  300: "Username",
  301: "Username & Password",
  302: "Username is required",
  303: "Users",
  304: "Version",
  305: "We are unable to communicate with the Pivot servers. Internet access is required for this app to work properly. Please check your data or Wi-Fi settings and try again.",
  306: "Welcome to Pivot",
  307: "Yes",
  309: "You cannot delete the last time period.",
  310: "You haven't saved any schedules yet.",
  311: "Your account has been created!",
  312: "Your network is unavailable. Check your data or Wi-Fi connection.",
  313: "The name of the period cannot be blank.",
  314: "The name of the period cannot contain emojis or special characters.",
  315: "Thermostat Fault Alerts Enabled",
  316: "Saving Setpoints...",
  317: "Setpoints saved successfully.",
  318: "Unexpected Error",
  319: "Apply setpoints to additional thermostats?",
  320: "Would you like to use your PIN to unlock the app when you open it?",
  321: "Would you like to use your #{BIOMETRICSTRING}# to unlock the app when you open it? Your PIN will be used if the #{BIOMETRICSTRING}# fails.",
  322: "Enter your Pivot username and password to reset your PIN",
  323: "Saving PINs...",
  324: "PINs saved successfully.",
  325: "Apply pins to additional thermostats?",
  326: "PIN must be four numeric digits",
  327: "Main Menu Passcode Enabled",
  328: "4 Digit Menu Passcode",
  329: "Technician Passcode Enabled",
  330: "4 Digit Technician Menu Passcode",
  331: "for that thermostat.", // Combined with 286
  332: "Our team of developers has been notified about the issue and is working on a fix.",
  333: "The page could not be found.",
  334: "Saving",
  335: "Telling #{NAME}# to #{ACTION}#",
  336: "This action cannot be completed because this building contains enrolled devices.",
  337: "Device Details",
  338: "The thermostat is not currently connected.",
  339: "End User License Agreement Terms and Conditions.", // Combined with 67
  340: "Are you sure you want to discard any changes to the schedule?",
  341: "Discard",
  342: "You must give the schedule a name.",
  343: "Saved Schedule",
  344: "Saved current schedule as #{NAME}#",
  345: "Saving schedule",
  346: "[#{NAME}#] already exists.\nDo you want to replace it?",
  347: "Couldn't load that schedule",
  348: "#{NAME}# is invalid and cannot be loaded.",
  349: "#{NAME}# does not match the temperature scale of the thermostat.",
  350: "Deleting '#{NAME}#'",
  351: "Saving thermostat schedule",
  352: "Saving schedules...",
  353: "Schedules saved successfully.",
  354: "Apply schedule to additional thermostats?",
  355: 'Loaded "#{NAME}#"',
  356: "There is nothing here yet.",
  357: "Note", // Combined with 198
  358: "Demo mode allows you to navigate throughout the Pivot app and explore how it operates.  As you use the Pivot app in this mode, any changes you make are not saved.",
  359: "Language",
  360: "Set automatically via this device",
  361: "Saving Language…",
  362: "Select Language",
  363: "A value is required.",
  364: "Edit",
  365: "Active Schedule",
  366: "Support Code",
  367: "Chrome Version",
  368: "Web View",
  369: "Unknown",
  370: "Password",
  371: "Mobile User",
  372: "Support Code",
  373: "HEAT",
  374: "COOL",
  375: "OFF",
  376: "Date too early",
  377: "Date too late",
  378: "on",
  379: "at",
  380: "by",
  381: "Device Event",
  382: "Scheduled Event",
  383: "Web Browsers",
  384: "Alert Subscriptions",
  385: "Filter",
  386: "Enroll #{DEVICE}#",
  387: "Enrolling #{DEVICE}#",
  388: "mon",
  389: "tue",
  390: "wed",
  391: "thu",
  392: "fri",
  393: "sat",
  394: "sun",
  395: "Are you sure you want to reset your password?",
  396: "Alert sent when humidity is above",
  397: "Alert sent when humidity is below",
  398: "Space Humidity Alert Enabled",
  399: "The software included in this product contains copyrighted software that is licensed under the GPL, LGPL or other copyleft license. A copy of those licenses is included herewith.  You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:",
  400: "Trane Commercial HVAC",
  401: "Attn: Open Source Compliance",
  402: "800-E Beaty St.",
  403: "PO Box 940",
  404: "Davidson, NC 28036",
  405: "Please include the name of the product and, if applicable, the version number of the software in the request letter. This offer is valid to anyone in receipt of this information.",
  406: "To transfer your account, please enter your password:",
  407: "Transfer Account",
  409: "Loading Account Transfer",
  410: "Hello!",
  411: "Please fill out the fields below in order to activate the Pivot account that was transferred to you.",
  412: "Thermostat Fault Alerts",
  413: "Enabled",
  414: "Disabled",
  415: "Space Temperature Alert",
  416: "Space Humidity Alert",
  417: "above ",
  418: "below ",
  419: "Send alert notification on:",
  420: "Alert Enabled",
  421: "Alert",
  422: "Username is permanently tied to account. Create a username meaningful to the owner.",
  423: "Alert Subscription Users",
  424: "Thermostats this user can control",
  425: "Add Contact",
  426: "Receives selected alerts at",
  427: "Edit Settings",
  428: "Delete Contact",
  429: "User alert subscriptions",
  430: "Send to",
  431: "At",
  432: "Phone",
  433: "All",
  434: "Custom",
  435: "Receive these alerts",
  436: "High and low limit cannot be same",
  437: "Higher limit must be greater than lower limit",
  438: "My push notification alerts",
  439: "this Mobile Device",
};



// WEBPACK FOOTER //
// ../nx-components/src/Locales/en_us_core.js